import request from '@/utils/request'

// 获取内页贴片
export function getModule(id) {
  return request({
    url: 'api/patch/module/' + id,
    method: 'get',
  });
}

// 获取单页内容
export function getContent(id) {
  return request({
    url: 'api/module/content/' + id,
    method: 'get',
  });
}

// 获取文章列表页
export function getPage(data) {
  return request({
    url: 'api/article/page',
    method: 'post',
    data: data
  });
}

// 获取文章详情页
export function getDetail(id) {
  return request({
    url: 'api/article/detail/' + id,
    method: 'get',
  });
}

// 相关推荐
export function getRecommend(articleId, size) {
  return request({
    url: 'api/article/recommend/' + articleId + '/' + size,
    method: 'get',
  });
}

// 获取选项卡全部数据  
export function getPageByParentModule(data) {
  return request({
    url: 'api/article/pageByParentModule',
    method: 'post',
    data: data
  });
}

// 文章查询
export function search(data) {
  return request({
    url: 'api/article/search',
    method: 'post',
    data: data
  });
}


// WEBPACK FOOTER //
// ./src/api/inner.js